// extracted by mini-css-extract-plugin
export default {"comment_all":"CommentEditor_comment_all__snJ51","coment_textarea":"CommentEditor_coment_textarea__m9rot","item_project":"CommentEditor_item_project__fuuhC"};